mobileSize = 900;
function countdown() {
  if ($('body').hasClass('saffireMobileSize')) {
    $('#siteInfoBannerWidget').insertBefore('#hotButtons');

  } else {
    $('#siteInfoBannerWidget').insertAfter('.header-content');
  }
}
function ticket() {
  if ($('body').hasClass('saffireMobileSize')) {
    $('.ticket').insertAfter('.header-content');
  } else {
    $('.ticket').insertAfter('.viewcart');
  }
}
$(document).ready(function () {
  $('.footer .saffire_logo').attr('src', FULLCLIENTTHEMEPATH + '/images/saffire-logo.png');
  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 900) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 900) {
    $('body').removeClass('saffireMobileSize');
  }

  // General Message
  $('.generalmessage').prependTo('header');
  countdown();
  ticket();
  $(".footerItems1 a").removeClass("button");
  const fes = $('.header .searchBox');
  fes.find('.searchBoxInput input').attr('value', 'Search');
  const fes1 = $('.tier-three-right .emailSignup ');
  fes1.find('.inputFieldTextbox').val('');
  fes1.find('.inputFieldTextbox').attr('placeholder', 'Enter Address');
  $(".arrow-down").on('click', function () {
    $('html, body').animate({
      'scrollTop': $(".outer-medium").position().top
    });
  });
});

$(window).load(function () {
  $('body').addClass('pageIsLoaded');

  $(".footerItems1 a").removeClass("button");
});


$(window).resize(function () {
  countdown();
  ticket();
  $(".footerItems1 a").removeClass("button");
});